import { Link, useNavigate } from 'react-router-dom';
import { Video, Sun, Moon, LogOut } from 'lucide-react';
import { useAppDispatch, useAppSelector } from '@/store';
import { setTheme } from '@/store/uiSlice';
import { useAuthContext } from '@/features/auth/AuthProvider';
import { config } from '@/config/env';

export default function AppHeader(): JSX.Element {
  const dispatch = useAppDispatch();
  const theme = useAppSelector((s) => s.ui.theme);
  const { user, logout } = useAuthContext();
  const navigate = useNavigate();

  const toggleTheme = () => dispatch(setTheme(theme === 'dark' ? 'light' : 'dark'));
  const onLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <header className="sticky top-0 z-10 border-b border-slate-200 bg-white/80 backdrop-blur dark:border-slate-800 dark:bg-slate-950/80">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3">
        <Link to="/dashboard" className="flex items-center gap-2 font-bold">
          <Video className="text-brand-600" /> {config.appName}
        </Link>
        <nav className="flex items-center gap-4 text-sm">
          <Link to="/meetings" className="hover:text-brand-600">Meetings</Link>
          <Link to="/recordings" className="hover:text-brand-600">Recordings</Link>
          <Link to="/analytics" className="hover:text-brand-600">Analytics</Link>
          <Link to="/settings" className="hover:text-brand-600">Settings</Link>
          {(user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN') && (
            <Link to="/admin" className="hover:text-brand-600">Admin</Link>
          )}
          <button onClick={toggleTheme} className="btn-ghost p-2" aria-label="Toggle theme">
            {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          <span className="hidden text-slate-500 sm:inline">{user?.firstName}</span>
          <button onClick={onLogout} className="btn-ghost p-2" aria-label="Log out">
            <LogOut size={18} />
          </button>
        </nav>
      </div>
    </header>
  );
}
